export default "__VITE_ASSET__DKg9BcQL__"